type FullscreenListener = (isOpen: boolean) => void;

class BiFullscreenManager {
	private isFullscreenOpen = false;
	private listeners: Set<FullscreenListener> = new Set();

	openFullscreen(): void {
		if (!this.isFullscreenOpen) {
			this.isFullscreenOpen = true;
			this.notifyListeners();
			window.dispatchEvent(
				new CustomEvent('bi-fullscreen-open', {
					detail: { isOpen: true },
				})
			);
		}
	}

	closeFullscreen(): void {
		if (this.isFullscreenOpen) {
			this.isFullscreenOpen = false;
			this.notifyListeners();
			window.dispatchEvent(
				new CustomEvent('bi-fullscreen-close', {
					detail: { isOpen: false },
				})
			);
		}
	}

	getIsFullscreenOpen(): boolean {
		return this.isFullscreenOpen;
	}

	subscribe(listener: FullscreenListener): () => void {
		this.listeners.add(listener);
		return () => {
			this.listeners.delete(listener);
		};
	}

	private notifyListeners(): void {
		this.listeners.forEach(listener => {
			listener(this.isFullscreenOpen);
		});
	}
}

export const biFullscreenManager = new BiFullscreenManager();
